import { EndpointDetailsView } from '../view/EndpointDetailsView';
import { templateEndpointDetails } from '../view/template';
import { EndpointDetailsRepository } from '../repository/EndpointDetailsRepository';
import { BaseWebComponentController } from '../../framework/BaseWebComponentController';
import { EndpointDetailsWebComponent } from '..';
import { EndpointDetailsWebComponentSchema } from '../types';

export class EndpointDetailsController extends BaseWebComponentController {
  public component: EndpointDetailsWebComponent;
  public dataRepository: EndpointDetailsRepository;
  public view: EndpointDetailsView;
  public viewConstructor: typeof EndpointDetailsView;
  public dataRepositoryConstructor: typeof EndpointDetailsRepository;

  constructor(component: EndpointDetailsWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: EndpointDetailsView,
      viewTemplate: templateEndpointDetails,
      dataRepositoryConstructor: EndpointDetailsRepository,
    });
  }

  async getDataForView(): Promise<EndpointDetailsWebComponentSchema> {
    return this.dataRepository.getEndpointDetails(this.component.endpointId);
  }
}
